import { defineComponent, computed } from "vue";
import { useReviewsStore } from "./customerReviewsStore";
import EmptyStarImage from "../../assets/stars/emptyStar.png";
import HalfStarImage from "../../assets/stars/halfStar.png";
import FullStarImage from "../../assets/stars/fullStar.png";
import { validationComment } from "./utilities/helpers";
export default defineComponent({
    name: "DealerDetails",
    components: {},
    setup() {
        const store = useReviewsStore();
        const totalReviewsAverageStars = computed(() => store.getTotalReviewsAverageStars());
        const title = ["Customer re", "V", "ie", "W", "s"];
        const averageScoreText = computed(() => `Average score ${store.totalReviewsAverage.substring(0, parseInt(store.totalReviewsAverage).toFixed(2).toString().length - 1)} `);
        const allReviewsText = computed(() => `(${store.getDealerInfo.numberOfRatings} reviews)`);
        return {
            title,
            validationComment,
            averageScoreText,
            allReviewsText,
            FullStarImage,
            HalfStarImage,
            EmptyStarImage,
            totalReviewsAverageStars,
        };
    },
});
